/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bar_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comma-, tab- or space-separated rows. The first column is treated as category labels and the remaining columns as numeric series; an all-text first row is used as the header.`)
};

const es_bar_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filas separadas por comas, tabulaciones o espacios. La primera columna se trata como etiquetas de categoría y las columnas restantes como series numéricas; una primera fila totalmente de texto se usa como cabecera.`)
};

const de_bar_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durch Kommas, Tabulatoren oder Leerzeichen getrennte Zeilen. Die erste Spalte wird als Kategoriebezeichnung behandelt und die übrigen Spalten als numerische Serien; eine reine Text-Kopfzeile wird als Kopfzeile verwendet.`)
};

const nl_bar_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komma-, tab- of spatiegescheiden rijen. De eerste kolom wordt behandeld als categorielabels en de overige kolommen als numerieke reeksen; een eerste rij die volledig uit tekst bestaat wordt als header gebruikt.`)
};

const fr_bar_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des lignes séparées par des virgules, des tabulations ou des espaces. La première colonne est traitée comme des étiquettes de catégorie et les colonnes restantes comme des séries numériques ; une première ligne entièrement textuelle est utilisée comme en-tête.`)
};

const it_bar_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Righe separate da virgole, tabulazioni o spazi. La prima colonna è trattata come etichette di categoria e le colonne rimanenti come serie numeriche; una prima riga interamente testuale viene usata come intestazione.`)
};

const pt_br2_bar_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linhas separadas por vírgula, tabulação ou espaço. A primeira coluna é tratada como rótulos de categoria e as colunas restantes como séries numéricas; uma primeira linha totalmente textual é usada como cabeçalho.`)
};

const pt_bar_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linhas separadas por vírgulas, tabulações ou espaços. A primeira coluna é tratada como rótulos de categoria e as restantes como séries numéricas; uma primeira linha totalmente textual é usada como cabeçalho.`)
};

const ja_bar_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カンマ、タブ、またはスペース区切りの行です。最初の列はカテゴリラベル、残りの列は数値系列として扱われます。すべて文字の最初の行はヘッダーとして使われます。`)
};

const zh_bar_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以逗号、制表符或空格分隔的行。第一列被视为类别标签，其余列视为数值系列；如果第一行全为文本，则用作表头。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bar_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bar_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bar_faq_a1", locale)
	if (locale === "en") return en_bar_faq_a1(inputs)
	if (locale === "es") return es_bar_faq_a1(inputs)
	if (locale === "de") return de_bar_faq_a1(inputs)
	if (locale === "nl") return nl_bar_faq_a1(inputs)
	if (locale === "fr") return fr_bar_faq_a1(inputs)
	if (locale === "it") return it_bar_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_bar_faq_a1(inputs)
	if (locale === "pt") return pt_bar_faq_a1(inputs)
	if (locale === "ja") return ja_bar_faq_a1(inputs)
	return zh_bar_faq_a1(inputs)
};